import Seniority from "./Seniority";

export default Seniority;
